import { Injectable } from "@angular/core";
import { TopicTagInterface } from "@core/interfaces/forums/topic.interface";

@Injectable({
  providedIn: "root"
})
export class TagSelectionService {
  selectPrimaryTag(tags: TopicTagInterface[]): TopicTagInterface | null {
    if (!tags || tags.length === 0) {
      return null;
    }

    const getPriority = (tag: TopicTagInterface): number => {
      switch (tag.category) {
        case "topic": // deep-sky, solar-system, comet
          return 100;
        case "solar-system": // individual planets
          return 90;
        case "equipment": // equipment items with brand/model
          // Equipment tags have subcategory like 'telescope', 'camera', etc.
          return 85;
        case "equipment-type": // reflectors, refractors, dslr, ccd
          return 80;
        case "workflow": // processing, acquisition, specific techniques
          return 70;
        case "imaging-type": // narrowband, broadband, rgb, etc.
          return 65;
        case "technique": // eaa
          return 60;
        case "equipment-maintenance": // collimation
          return 50;
        case "environment": // light-pollution, seeing, etc.
          return 40;
        case "education": // how-to, tutorial
        case "content-type": // review
          return 35;
        case "experience": // beginner, intermediate, advanced
          return 30;
        case "engagement": // request-for-feedback
          return 25;
        case "meta": // introductions, off-topic
          return 20;
        case "language":
          return 10;
        default:
          return 15;
      }
    };

    return tags.sort((a, b) => getPriority(b) - getPriority(a))[0];
  }
}
